import {Pipe, PipeTransform} from "@angular/core";
import {EExerciseType} from "../enums/EExerciseType";
import {ECompanionMode} from "../enums/ECompanionMode";

@Pipe({
  name: "endType",
})
export class EndTypePipe implements PipeTransform {
  transform(
    value: unknown,
    exerciseType: EExerciseType,
    companionMode?: ECompanionMode,
  ): string {
    if (value === 1) return "seconds";
    if (
      exerciseType === EExerciseType.Agility ||
      (exerciseType === EExerciseType.Companion &&
        companionMode === ECompanionMode.Agility)
    ) {
      return "arrows";
    }
    return "touches";
  }
}
